import "core-js/modules/es.array.concat.js";

/* eslint-disable no-underscore-dangle */

/* eslint-disable import/prefer-default-export */
var _locks = {};
export function lock(target, name, descriptor) {
  var _this = this;

  var oldValue = descriptor.value;

  var _name = "".concat(target.className, ".").concat(name); // eslint-disable-next-line no-param-reassign


  descriptor.value = function () {
    if (_locks[_name]) {
      return _locks[_name];
    }

    for (var _len = arguments.length, arg = new Array(_len), _key = 0; _key < _len; _key++) {
      arg[_key] = arguments[_key];
    }

    var promise = oldValue.apply(_this, arg);

    if (promise.then && promise.catch) {
      _locks[_name] = promise.then(function (res) {
        delete _locks[_name];
        return res;
      }).catch(function (err) {
        delete _locks[_name];
        throw err;
      });
    }

    return _locks[_name] || promise;
  };
}